import { AbstractTagClass } from 'tag/ts/tag/abstract/AbstractTagClass';
import { FreewheelConstants } from 'tag/ts/tag/model/FreewheelConstants';
import { FreewheelPauseAdConstants } from 'tag/ts/tag/model/FreewheelPauseAdConstants';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { FWUtilities } from 'tag/ts/tag/utilities/FWUtilities';
export class AbstractFreewheelClass extends AbstractTagClass {
    constructor(argument) {
        super({
            name: 'AbstractFreewheelClass',
            ...argument
        });
    }
    #toUrlTransformers = {
        [this.fwConstants.randomTag]: (value) => {
            this?.logger?.log(`toUrlTransformers[${this.fwConstants.randomTag}]`, 'value:', value, ' should not be encoded... returning constant:', this.fwConstants.randomTag);
            return this.fwConstants.randomTag;
        }
    };
    #defaultToUrlTransformer = (value) => {
        const res = encodeURIComponent((value.toString()));
        this?.logger?.log('defaultToUrlTransformer', 'encoding value:', value, '...returning:', res);
        return res;
    };
    get fwConstants() {
        return FreewheelConstants.getInstance();
    }
    get pauseAdConstants() {
        return FreewheelPauseAdConstants.getInstance();
    }
    get fwUtil() {
        return FWUtilities.getInstance();
    }
    get siteSessionData() {
        return this?.tag?.model?.siteUtilities?.siteSessionData;
    }
    getSystemDevice() {
        return this?.params?.SYSTEM?.device;
    }
    getSystemEmbedType() {
        return this?.params?.SYSTEM?.embedType;
    }
    getBusinessDivision() {
        if (this.isPPlus()) {
            return 'streaming';
        }
        else {
            return 'vcbs';
        }
    }
    getPartner() {
        if (this.isPPlus()) {
            return 'paramountplus';
        }
        else {
            return 'cbs';
        }
    }
    getRegion() {
        return this.siteSessionData?.region;
    }
    getPlatform() {
        if (this.isDesktop()) {
            return 'desktop';
        }
        else {
            return 'mobile';
        }
    }
    getStreamType() {
        if (this.isLive()) {
            return 'live';
        }
        else {
            return 'vod';
        }
    }
    getVendorCode() {
        return this?.tag?.params?.CONTEXT?.metadata?.vendorCode || '';
    }
    createSiteSectionId(delimiter = '_') {
        let sectionValues;
        switch (this.getSystemEmbedType()) {
            case EmbedType.DESKTOP:
            case EmbedType.MOBILE_WEB:
                sectionValues = this.getSectionValuesForWeb();
                break;
            case EmbedType.HTML5:
                sectionValues = this.getSectionValuesForHtml5();
                break;
            default:
                this?.logger?.warn('createSiteSectionId', 'unknown EmbedType... default to csid for web', 'EmbedType:', this.getSystemEmbedType());
                sectionValues = this.getSectionValuesForWeb();
        }
        return sectionValues
            .filter((value) => value?.trim().length > 0)
            .join(delimiter)
            .toLowerCase();
    }
    getSectionValuesForWeb() {
        return [
            this.getBusinessDivision(),
            this.getPartner(),
            this.getRegion(),
            this.getPlatform(),
            'web',
            this.getStreamType(),
            this.getVendorCode()
        ];
    }
    getSectionValuesForHtml5() {
        return [
            this.getBusinessDivision(),
            this.getPartner(),
            this.getCountryCode(),
            'ctv',
            (this.getSystemDevice()?.toLowerCase() || 'unknown'),
            this.getStreamType()
        ];
    }
    toUrlParam(value) {
        if (this.utils.Type.isNullOrUndefined(value) ||
            (!this.utils.Type.isString(value) &&
                !this.utils.Type.isNumber(value) &&
                !this.utils.Type.isBoolean(value))) {
            this?.logger?.warn('toUrlParam', 'missing/invalid value... returning value unmodified:', value);
            return value;
        }
        let handlerToExecute = this.#toUrlTransformers[value];
        if (this.utils.Type.isNullOrUndefined(handlerToExecute)) {
            this?.logger?.log('toUrlParam', 'no matching transformers in toUrlTransformers... fallback to defaultToUrlTransformer');
            handlerToExecute = this.#defaultToUrlTransformer;
        }
        const res = handlerToExecute(value);
        this?.logger?.log('toUrlParam', 'value:', value, '...returning url-safe string:', res);
        return res;
    }
    createLanguageSelection() {
        let langSelection = (this?.settings?.audioTrack?.language ||
            this?.siteSessionData?.language_selection ||
            this?.params?.CONTENT?.locale);
        if (langSelection?.includes('-')) {
            langSelection = langSelection.substring(0, langSelection.indexOf('-'));
        }
        return langSelection;
    }
}
